import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
import { StyledChipLabel } from './ChipLabel.styles';

/**
 * A wrapper for the text node inside of an AssistChip. Allows us to truncate long
 * label text.
 *
 * @since 8.97.0
 */
export var ChipLabel = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  return /*#__PURE__*/React.createElement(StyledChipLabel, _extends({
    ref: forwardedRef
  }, props));
});
ChipLabel.displayName = 'ChipLabel';